<div class="tabs__panel" [attr.aria-labelledby]="'tab-' + id" [id]="'tab-panel-' + id" *ngIf="selected">
  <ng-content></ng-content>
</div>
